<template>
    <path d="M9.53284 15.6387L5.81156 11.2638H0.576172V0.638672H14.4529V11.2638H10.101L9.53284 15.6387ZM1.83741 10.0141H6.44218L8.65013 12.6388L9.02865 10.0141H13.1917V1.88842H1.83741V10.0141Z"/>
</template>

<script>
export default {
  name: 'IconComment',
}
</script>
